import { Component, OnInit } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { MedigiComponentCopyService } from '../medigi-component-copy.service';

@Component({
  selector: 'app-medigi-manufacturer-info',
  templateUrl: './manufacturer-info.component.html',
  styleUrls: ['./manufacturer-info.component.scss'],
})
export class MeidigiManufacturerInfoComponent implements OnInit {
  quoteCard;

  constructor(
    private medigiCopyService: MedigiComponentCopyService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  ngOnInit() {
    this.getCopy();
  }

  getCopy() {
    this.quoteCard = this.medigiCopyService.cards.largeCard.generalQuotes;
  }

  openChat() {
    let chatlio = document.getElementById('chatlio-widget');
    let chatlioWdiget = chatlio.getElementsByClassName('chatlio-widget');
    chatlioWdiget[0].classList.remove('chatlio-closed');
    chatlioWdiget[0].classList.add('chatlio-open');
  }

  openPDF() {
    window.open('/assets/docs/Manufacturer-Page-Download_F.pdf', '_blank');
  }

  sendToGa(eventName, eventCategory) {
    this.googleAnalyticsService.eventEmitter(eventCategory, eventName);
  }
}
